import React from 'react'
import { formatCurrency, formatPercentage } from '../../shared/utils'
const DashboardCards = ({ title, icon, value }) => {
  const formatDashboardValue = () => {
    if (title === "# of Orders" || title === "# of Pending Orders" || title === "Total Direct Orders") {
      return Math.floor(value || 0)
    } else if (title === "Average Pa %") {
      return formatPercentage(value)
    } else if (
      title === "Order total" ||
      title === "Total PA" ||
      title === "Pending PA" ||
      title === "Paid PA" ||
      title === "Total Order Amount" ||
      title === "Total Orders Amount" ||
      title === "Pending Orders Amount" ||
      title === "Total Pa Amount" ||
      title === "Total PA Amount" ||
      title === "Total Direct Amount" ||
      title === "Origins Direct Bonus"
    ) {
      // Format as number with dollar sign but without decimals
      const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : (value || 0)
      return '$' + Math.round(numValue).toLocaleString()
    } else {
      return formatCurrency(value)
    }
  }
  return (
    <div className='mb-4'>
      <div className='float-start mini-stat-img me-4'>
        <img src={icon} alt='' />
      </div>
      <h5 className='font-size-13 text-uppercase mt-0 text-white-50'>
        {title}
      </h5>
      <h4 className='fw-medium font-size-16'>{formatDashboardValue()}</h4>
    </div>
  )
}

export default DashboardCards
